import { BaseStore } from "@infrastructure/stores/_base.store";

export interface CardInfo {
  id: number;
  pan: string;
  exp_date: string;
  is_chosen: boolean;
}

type CreditCardStoreState = {
  savedCards: CardInfo[];
};

class CreditCardStoreFactory extends BaseStore<CreditCardStoreState> {
  savedCards: CardInfo[] = [];

  constructor() {
    super();
  }

  protected createState(): CreditCardStoreState {
    return {
      savedCards: this.savedCards,
    };
  }

  protected getStateKey(): string {
    return `cards:${this.savedCards.length}`;
  }

  /**
   * Устанавливает карты
   */
  setCards(cards: CardInfo[]) {
    this.savedCards = cards;
    this.notifyListeners();
  }

  /**
   * Добавляет карту
   */
  addCard(card: CardInfo) {
    this.savedCards = [...this.savedCards, card];
    this.notifyListeners();
  }

  /**
   * Удаляет карту
   */
  removeCard(cardId: number) {
    this.savedCards = this.savedCards.filter((card) => card.id !== cardId);
    this.notifyListeners();
  }

  /**
   * Устанавливает карту по умолчанию
   */
  setDefaultCard(cardId: number) {
    this.savedCards = this.savedCards.map((card) => ({
      ...card,
      is_chosen: card.id === cardId,
    }));
    this.notifyListeners();
  }
}

export const CreditCardStore = new CreditCardStoreFactory();

